import { createContext, useContext } from "react";

/** The pipelines the Run AI dialog lists, one row each. */
export const RUN_AI_HUB_PIPELINES = [
  "script_breakdown",
  "character_breakdown",
  "coverage",
  "schedule",
  "budget",
] as const;

export type RunAiHubPipeline = (typeof RUN_AI_HUB_PIPELINES)[number];

/**
 * Opens the Run AI dialog. With a pipeline, that row is highlighted and its
 * Run button takes focus; the user still clicks Run (and any confirm). With
 * no pipeline, the dialog opens exactly as it always has.
 */
export type OpenRunAiHub = (pipeline?: RunAiHubPipeline) => void;

export const isRunAiHubPipeline = (value: unknown): value is RunAiHubPipeline =>
  typeof value === "string" && (RUN_AI_HUB_PIPELINES as readonly string[]).includes(value);

export type ProjectScriptAiHubContextValue = {
  openRunAiHub: OpenRunAiHub;
  isAvailable: boolean;
};

/**
 * Kept apart from the provider so app chrome (the header, a step's empty
 * page) can open the Run AI hub without importing the script editor.
 */
export const ProjectScriptAiHubContext = createContext<ProjectScriptAiHubContextValue | null>(null);

export function useProjectScriptAiHub(): ProjectScriptAiHubContextValue | null {
  return useContext(ProjectScriptAiHubContext);
}

export function useOpenProjectScriptAiHub(): OpenRunAiHub | null {
  const hub = useProjectScriptAiHub();
  return hub?.isAvailable ? hub.openRunAiHub : null;
}
